var map = {
	"./i4pro-ecm-banner.vue": 87425,
	"./i4pro-ecm-file.vue": 86855,
	"./i4pro-ecm-list-download.vue": 54231,
	"./i4pro-ecm.vue": 612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36704;